/** ml-scribe's catalogued `detail.type` values for the team upgrade intent routes. */
export type TeamUpgradeErrorType =
  | 'TeamUpgradeNotWorkspaceAdmin'
  | 'TeamUpgradeInvalidSelection'
  | 'TeamUpgradeMemberNotBillable'
  | 'TeamUpgradeMemberNotInWorkspace'
  | 'TeamUpgradeUpgradedUserRemoved'
  | 'TeamUpgradeNotSupported'
  | 'TeamUpgradeTierItemNotFound'
  | 'TeamUpgradePaymentTotalMismatch'
  | 'TeamUpgradeSeatCount'
  | 'TeamUpgradePreviewUnavailable'
  | 'TeamUpgradeIntentNotFound'
  | 'TeamUpgradeSchedulingPaused'
  | 'TeamUpgradeExecuteFailed';

type HttpErrorShape = {
  response?: { status?: number; data?: { detail?: { type?: unknown } } };
};

export const teamUpgradeErrorStatus = (error: unknown): number | undefined =>
  (error as HttpErrorShape | null)?.response?.status;

/** The catalogued error type of a failed team upgrade call, if the server sent one. */
export function getTeamUpgradeErrorType(
  error: unknown
): TeamUpgradeErrorType | undefined {
  const type = (error as HttpErrorShape | null)?.response?.data?.detail?.type;
  return typeof type === 'string' && type.startsWith('TeamUpgrade')
    ? (type as TeamUpgradeErrorType)
    : undefined;
}

/** A 4xx is a decision, not a blip: retry only network failures and 5xx. */
export const retryTeamUpgradeQuery = (failureCount: number, error: unknown) => {
  const status = teamUpgradeErrorStatus(error);
  if (status !== undefined && status < 500) return false;
  return failureCount < 2;
};
